import { SEARCH_PERSON_SUCCESSFUL_FETCH, SHOW_ERROR_MESSAGE } from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const searchPersons = (searchCriteria, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/parties/not-customers",
        {
            params: {
                searchCriteria: searchCriteria
            }
        })
        .then((response) => {
            dispatch({
                type: SEARCH_PERSON_SUCCESSFUL_FETCH,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}


// WEBPACK FOOTER //
// ./src/reducers/person/personActions.js